import * as XLSX from "xlsx";

const generateWorkbook = <T>(data: T[][]) => {
  const workSheet = XLSX.utils.aoa_to_sheet(data);
  const workBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workBook, workSheet, "Sheet1");
  return workBook;
};

// This is a generic function to export data type Array<Array<T>> to a XLSX file
export const exportDataToXLSX = <T>(data: T[][], filename: string) => {
  const workBook = generateWorkbook(data);
  XLSX.writeFile(workBook, `${filename}.xlsx`);
};

// Used for generating XLSX exports from a worker, since workers cannot use
// XLSX.writeFile directly: https://docs.sheetjs.com/docs/demos/bigdata/worker/
export const generateXLSXDownloadURL = <T>(data: T[][]) => {
  const workBook = generateWorkbook(data);
  const u8 = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
  return URL.createObjectURL(new Blob([u8]));
};
